import "./App.css";
import Login from "./auth/Login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ShipmentDetails from "./pages/ShipmentDetails";

import { QueryClient, QueryClientProvider } from "react-query";
import CsHome from "./pages/CsHome";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#25314e", // Logo Dark Navy Blue
      dark: "#151e2e",
      light: "#3a4a70",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ef4b1f", // Logo Accent Orange
      dark: "#d83a12",
      light: "#ff744c",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
    },
    text: {
      primary: "#0f172a",
      secondary: "#475569",
      disabled: "#94a3b8",
    },
    action: {
      hover: "rgba(239, 75, 31, 0.04)",
    },
  },
  typography: {
    fontFamily: "'Cairo', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    body1: { fontSize: "0.95rem", lineHeight: 1.6 },
    body2: { fontSize: "0.875rem", lineHeight: 1.6 },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          padding: "8px 20px",
          fontWeight: 600,
          boxShadow: "none",
          transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: "0 4px 12px rgba(37, 49, 78, 0.12)",
          },
          "&:active": {
            transform: "translateY(0)",
          },
        },
        containedPrimary: {
          background: "linear-gradient(135deg, #25314e 0%, #1c263c 100%)",
          "&:hover": {
            background: "linear-gradient(135deg, #2e3d62 0%, #25314e 100%)",
            boxShadow: "0 4px 16px rgba(37, 49, 78, 0.2)",
          },
        },
        containedSecondary: {
          background: "linear-gradient(135deg, #ef4b1f 0%, #e03f14 100%)",
          "&:hover": {
            background: "linear-gradient(135deg, #ff5e33 0%, #ef4b1f 100%)",
            boxShadow: "0 4px 16px rgba(239, 75, 31, 0.25)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            transition: "all 0.2s ease-in-out",
            backgroundColor: "#ffffff",
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#25314e",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ef4b1f",
              borderWidth: "2px",
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          boxShadow: "0 4px 24px rgba(15, 23, 42, 0.04)",
          border: "1px solid rgba(226, 232, 240, 0.8)",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "16px",
          padding: "8px",
          border: "none",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.12)",
        },
      },
    },
  },
});

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/cs-home" element={<CsHome />} />
            <Route path="/shipment-details" element={<ShipmentDetails />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
